import './Loader.scss';

import React, { memo, useMemo } from 'react';

import { Spin, SpinProps } from 'antd';

import { LoadingOutlined } from '@ant-design/icons';

import { useTheme } from '../../../context/ThemeProvider';
import DotsFlashingLoader, {
  DotsFlashingLoaderProps,
} from './DotsFlashingLoader';

export interface LoaderProps extends SpinProps {
  type?: 'spinner' | 'dots' | 'roller' | 'dots-flashing';
  color?: string;
  dotsFlashingLoaderProps?: DotsFlashingLoaderProps;
  isFullScreen?: boolean;
  style?: React.CSSProperties;
  loadingStyle?: React.CSSProperties;
}

const Loader: React.FC<LoaderProps> = ({
  dotsFlashingLoaderProps,
  ...props
}) => {
  const { colors: COLORS } = useTheme();

  const {
    type = 'spinner',
    color = COLORS.PRIMARY,
    isFullScreen,
    style,
    loadingStyle,
  } = props;

  const renderedLoader = useMemo(() => {
    switch (type) {
      case 'dots':
        return <Spin {...props} style={{ color }} />;
      case 'dots-flashing':
        return (
          <DotsFlashingLoader
            color={color}
            style={style}
            {...dotsFlashingLoaderProps}
          />
        );
      case 'roller':
        return (
          <div className="loading--roller">
            {Array(8)
              .fill(0)
              .map((_, index) => (
                <div key={`roller-${index}`} />
              ))}
          </div>
        );
      default:
        return (
          <LoadingOutlined
            style={{
              ...loadingStyle,
              color,
            }}
          />
        );
    }
  }, [color, dotsFlashingLoaderProps, loadingStyle, props, style, type]);

  return (
    <div
      className="tm-loader tm-loader-wrapper"
      style={{
        ...style,
        ...(isFullScreen
          ? {
              position: 'fixed',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999,
            }
          : {}),
      }}>
      {renderedLoader}
    </div>
  );
};

export default memo(Loader);
